import { render } from "./EmployeePunch.vue?vue&type=template&id=48b9f4c6&scoped=true"
import script from "./EmployeePunch.vue?vue&type=script&lang=js"
export * from "./EmployeePunch.vue?vue&type=script&lang=js"

import "./EmployeePunch.vue?vue&type=style&index=0&id=48b9f4c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b9f4c6"]])

export default __exports__